import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { MultipleAddressesTaxFields, TaxFields } from './createLoanFields/TaxFields';
import { MultiPropertyInsuranceFields, PrimaryPropertyInsuranceFields } from './sharedFields/InsuranceFields';
import { MultiPropertyTaxFields, PrimaryPropertyTaxFields } from './sharedFields/TaxNestedFields';

export const UpdateEscrowSettingsRow = z.object({
  loanId: LosId,
  ...PrimaryPropertyInsuranceFields.shape,
  ...MultiPropertyInsuranceFields.shape,
  ...TaxFields.shape,
  ...MultipleAddressesTaxFields.shape,
  ...PrimaryPropertyTaxFields.shape,
  ...MultiPropertyTaxFields.shape,
  addressCounty: z.string().optional(),
});

export type UpdateEscrowSettingsRow = z.infer<typeof UpdateEscrowSettingsRow>;

export const UPDATE_ESCROW_SETTINGS_ROW_REQUIRED_FIELDS = Object.keys(UpdateEscrowSettingsRow.shape).filter(
  (key) => !UpdateEscrowSettingsRow.shape[key as keyof typeof UpdateEscrowSettingsRow.shape].isOptional(),
) as (keyof UpdateEscrowSettingsRow)[];

// API-only row shape: nested tax inputs only, no flat tax fields.
// County names live on address*Tax.county.countyName, so AddressCountyFields is dropped here.
// The Flatfile/CSV flow continues to use UpdateEscrowSettingsRow.
// Strict so that sending a legacy flat field (e.g. taxCountyIsEscrowed, addressCounty) surfaces
// a clear error instead of being silently dropped.
export const UpdateEscrowSettingsApiRow = z
  .object({
    loanId: LosId,
    ...PrimaryPropertyInsuranceFields.shape,
    ...MultiPropertyInsuranceFields.shape,
    ...PrimaryPropertyTaxFields.shape,
    ...MultiPropertyTaxFields.shape,
  })
  .strict();

export type UpdateEscrowSettingsApiRow = z.infer<typeof UpdateEscrowSettingsApiRow>;
